import { DependencyList, useCallback, useEffect, useRef } from 'react'
import useStableCallback from './useStableCallback'

type Destructor = () => void

export const useEffectUntil = (
  fn: (params: { stop: () => void }) => void | Destructor,
  deps: DependencyList,
) => {
  const stableFn = useStableCallback(fn)
  const stopRef = useRef(false)
  const stop = useCallback(() => {
    stopRef.current = true
  }, [])
  useEffect(() => {
    if (!stopRef.current) {
      stableFn({ stop })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps, stableFn, stop])
}
